import ZkFormItem from '../form/src/form-item';

/* istanbul ignore next */
ZkFormItem.install = function(Vue) {
  Vue.component(ZkFormItem.name, ZkFormItem);
};

export default ZkFormItem;



// WEBPACK FOOTER //
// ./src/packages/form-item/index.js